import * as Sentry from '@sentry/browser';

const configSentry = () => {
  if (process.env.SENTRY_DNS) {
    Sentry.init({
      dsn: process.env.SENTRY_DNS,
      release: 'proc-zkai-' + process.env.GIT_COMMIT_HASH,
      environment: __PRODUCTION__ ? 'production' : __STAGING__ ? 'staging' : 'dev',
    });

    return Sentry;
  }

  return {
    captureException: error => {
      console.error(error);
    },
    captureMessage: message => {
      console.warn(message);
    },
  };
};

export default configSentry();
